import { KindAllNodeStringStoreProvider } from '../Store'

import { KindAllNodeStringCascaderCore } from './Core'
import { KindAllNodeStringCascaderProps } from './interface'

export const KindAllNodeStringCascader = <M extends boolean>({
  /* -------------------------------------------------------------------------- */
  /*                       KindAllNodeStringStoreProvider Props                       */
  /* -------------------------------------------------------------------------- */
  valueKey: selectedField,
  multiple,
  value,
  onChange,
  /* -------------------------------------------------------------------------- */
  /*                        KindAllNodeStringCascaderCore Props                       */
  /* -------------------------------------------------------------------------- */
  ...restProps
}: KindAllNodeStringCascaderProps<M>) => {
  return (
    <KindAllNodeStringStoreProvider
      multiple={multiple}
      value={value}
      valueKey={selectedField}
      onChange={onChange}
    >
      <KindAllNodeStringCascaderCore {...restProps} />
    </KindAllNodeStringStoreProvider>
  )
}
